import { esApuntesPalettes } from "../../../../Posts/05-tematicas/03-apuntes/apuntesPalettes.js";
import * as React from 'react';
export default {
  esApuntesPalettes,
  React
};